<template>
  <svg  version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 1240 558" style="enable-background:new 0 0 1240 558;" xml:space="preserve">
  <g id="FILL">
	<polygon id="G01" class="svg-floorplate" points="773.42,378.28 838.64,378.28 838.64,264.28 773.42,264.28 773.42,316.39 612.08,316.39
		612.08,399.45 773.42,399.45 	"/>
	<polygon id="G02" class="svg-floorplate" points="950.94,264.28 838.64,264.28 838.64,378.28 890.68,378.28 890.68,393.75 950.94,393.75 	"/>

		<rect id="G03" x="834.5" y="117.73" transform="matrix(-1.069883e-06 1 -1 -1.069883e-06 1068.6727 -717.5783)" class="svg-floorplate" width="117.26" height="115.63"/>

		<rect id="G04" x="720.5" y="119.39" transform="matrix(-1.069883e-06 1 -1 -1.069883e-06 954.6982 -603.5513)" class="svg-floorplate" width="117.26" height="112.37"/>

		<rect id="G05" x="609.14" y="119.89" transform="matrix(-1.069883e-06 1 -1 -1.069883e-06 842.8297 -492.193)" class="svg-floorplate" width="116.75" height="110.85"/>

		<rect id="G06" x="441.95" y="121.02" transform="matrix(-1.069883e-06 1 -1 -1.069883e-06 676.1011 -320.9905)" class="svg-floorplate" width="113.19" height="113.08"/>
	<router-link :to="{ name: 'apartment', params: {apartment:  7}}">
		<polygon id="G07" class="svg-transparent" points="442.01,234.15 442.01,110.38 322.31,110.38 322.31,139.69 271.82,139.69 271.82,234.16 	"/>
	</router-link>
	<polygon id="G08" class="svg-floorplate" points="271.82,123.4 209.12,123.4 209.12,85.95 140.72,85.95 140.72,182.03 156.19,182.03
		156.19,205.65 140.72,205.65 140.72,234.15 271.82,234.15 	"/>
	<polygon id="G09" class="svg-floorplate" points="271.81,375.02 209.11,375.02 209.12,411.66 140.72,411.66 140.72,316.39 156.19,316.39
		156.19,291.96 140.72,291.96 140.72,264.28 271.82,264.28 	"/>
	<polygon id="G10" class="svg-floorplate" points="442.01,264.28 442.01,391.31 322.31,391.31 322.31,361.18 271.82,361.18 271.82,264.28 	"/>

		<rect id="G11" x="439.92" y="266.37" transform="matrix(-1.069883e-06 1 -1 -1.069883e-06 821.4523 -175.6389)" class="svg-floorplate" width="117.26" height="113.08"/>
</g>
<g id="STROKES">
	<line class="st2" x1="140.72" y1="316.39" x2="140.72" y2="411.66"/>
	<line class="st2" x1="950.94" y1="301.74" x2="950.94" y2="393.75"/>
	<line class="st2" x1="612.08" y1="390.49" x2="555.08" y2="390.49"/>
	<line class="st2" x1="612.08" y1="156.79" x2="555.08" y2="156.79"/>
	<line class="st2" x1="156.19" y1="316.39" x2="140.72" y2="316.39"/>
	<line class="st2" x1="156.19" y1="291.96" x2="156.19" y2="316.39"/>
	<line class="st2" x1="140.72" y1="291.96" x2="156.19" y2="291.96"/>
	<line class="st2" x1="156.19" y1="234.15" x2="156.19" y2="264.28"/>
	<line class="st2" x1="442.01" y1="381.54" x2="555.08" y2="381.54"/>
	<line class="st2" x1="322.31" y1="361.18" x2="271.82" y2="361.18"/>
	<line class="st2" x1="322.31" y1="391.31" x2="322.31" y2="361.18"/>
	<line class="st2" x1="442.01" y1="391.31" x2="322.31" y2="391.31"/>
	<line class="st2" x1="271.82" y1="432.84" x2="442.01" y2="432.84"/>
	<line class="st2" x1="156.19" y1="446.68" x2="156.19" y2="411.66"/>
	<line class="st2" x1="271.82" y1="446.68" x2="156.19" y2="446.68"/>
	<line class="st2" x1="271.82" y1="264.28" x2="271.82" y2="446.68"/>
	<line class="st2" x1="209.12" y1="375.02" x2="271.82" y2="375.02"/>
	<line class="st2" x1="209.12" y1="411.66" x2="209.12" y2="375.02"/>
	<line class="st2" x1="140.72" y1="411.66" x2="209.12" y2="411.66"/>
	<line class="st2" x1="140.72" y1="264.28" x2="140.72" y2="291.96"/>
	<line class="st2" x1="555.08" y1="264.28" x2="140.72" y2="264.28"/>
	<line class="st2" x1="442.01" y1="452.38" x2="442.01" y2="264.28"/>
	<line class="st2" x1="555.08" y1="448.31" x2="442.01" y2="452.38"/>
	<line class="st2" x1="555.08" y1="264.28" x2="555.08" y2="448.31"/>
	<line class="st2" x1="442.01" y1="120.96" x2="555.08" y2="120.96"/>
	<line class="st2" x1="442.01" y1="234.15" x2="442.01" y2="90.83"/>
	<line class="st2" x1="322.31" y1="110.38" x2="442.01" y2="110.38"/>
	<line class="st2" x1="322.31" y1="139.69" x2="322.31" y2="110.38"/>
	<line class="st2" x1="271.82" y1="139.69" x2="322.31" y2="139.69"/>
	<line class="st2" x1="271.82" y1="90.83" x2="271.82" y2="234.15"/>
	<line class="st2" x1="209.12" y1="123.4" x2="271.82" y2="123.4"/>
	<line class="st2" x1="209.12" y1="85.95" x2="209.12" y2="123.4"/>
	<line class="st2" x1="555.08" y1="90.83" x2="209.12" y2="90.83"/>
	<line class="st2" x1="140.72" y1="85.95" x2="209.12" y2="85.95"/>
	<line class="st2" x1="140.72" y1="182.03" x2="140.72" y2="85.95"/>
	<line class="st2" x1="156.19" y1="182.03" x2="140.72" y2="182.03"/>
	<line class="st2" x1="156.19" y1="205.65" x2="156.19" y2="182.03"/>
	<line class="st2" x1="140.72" y1="205.65" x2="156.19" y2="205.65"/>
	<line class="st2" x1="140.72" y1="234.15" x2="140.72" y2="205.65"/>
	<line class="st2" x1="555.08" y1="234.15" x2="140.72" y2="234.15"/>
	<line class="st2" x1="555.08" y1="90.83" x2="555.08" y2="234.15"/>
	<line class="st2" x1="1081.23" y1="393.75" x2="1000.61" y2="393.75"/>
	<line class="st2" x1="1081.23" y1="160.86" x2="1081.23" y2="393.75"/>
	<line class="st2" x1="950.94" y1="160.86" x2="1081.23" y2="160.86"/>
	<line class="st2" x1="835.31" y1="234.15" x2="835.31" y2="90.83"/>
	<line class="st2" x1="722.94" y1="234.15" x2="722.94" y2="90.83"/>
	<line class="st2" x1="838.64" y1="448.31" x2="838.64" y2="264.28"/>
	<line class="st2" x1="950.94" y1="448.31" x2="950.94" y2="393.75"/>
	<line class="st2" x1="770.98" y1="448.31" x2="950.94" y2="448.31"/>
	<line class="st2" x1="770.98" y1="432.84" x2="770.98" y2="448.31"/>
	<line class="st2" x1="612.08" y1="432.84" x2="770.98" y2="432.84"/>
	<line class="st2" x1="612.08" y1="399.45" x2="612.08" y2="432.84"/>
	<line class="st2" x1="612.08" y1="90.83" x2="612.08" y2="116.89"/>
	<line class="st2" x1="950.94" y1="90.83" x2="612.08" y2="90.83"/>
	<line class="st2" x1="612.08" y1="116.89" x2="950.94" y2="116.89"/>
	<line class="st2" x1="612.08" y1="234.15" x2="612.08" y2="116.89"/>
	<line class="st2" x1="950.94" y1="234.15" x2="612.08" y2="234.15"/>
	<line class="st2" x1="773.42" y1="264.28" x2="950.94" y2="264.28"/>
	<line class="st2" x1="770.98" y1="316.39" x2="612.08" y2="316.39"/>
	<line class="st2" x1="773.42" y1="264.28" x2="773.42" y2="316.39"/>
	<line class="st2" x1="612.08" y1="272.42" x2="773.42" y2="272.42"/>
	<line class="st2" x1="612.08" y1="399.45" x2="612.08" y2="272.42"/>
	<line class="st2" x1="773.42" y1="399.45" x2="612.08" y2="399.45"/>
	<line class="st2" x1="773.42" y1="378.28" x2="773.42" y2="399.45"/>
	<line class="st2" x1="890.68" y1="378.28" x2="773.42" y2="378.28"/>
	<line class="st2" x1="890.68" y1="393.75" x2="890.68" y2="378.28"/>
	<line class="st2" x1="1000.61" y1="393.75" x2="890.68" y2="393.75"/>
	<line class="st2" x1="1000.61" y1="301.74" x2="1000.61" y2="393.75"/>
	<line class="st2" x1="950.94" y1="301.74" x2="1000.61" y2="301.74"/>
	<line class="st2" x1="950.94" y1="90.83" x2="950.94" y2="301.74"/>
	<line class="st2" x1="838.64" y1="264.28" x2="838.64" y2="378.28"/>
	<line class="st2" x1="835.31" y1="378.28" x2="890.68" y2="378.28"/>
	<line class="st2" x1="890.68" y1="378.28" x2="890.68" y2="393.75"/>
	<line class="st2" x1="890.68" y1="393.75" x2="950.94" y2="393.75"/>
	<line class="st2" x1="950.94" y1="393.75" x2="950.94" y2="264.28"/>
	<line class="st2" x1="950.94" y1="264.28" x2="835.31" y2="264.28"/>
</g>
<g id="KEY_FRAME">
	<polyline class="st3" points="555.08,90.83 555.08,156.78 555.08,156.79 612.08,156.79 612.08,116.89 612.08,90.83 950.94,90.83
		950.94,160.86 1081.23,160.86 1081.23,393.75 1000.61,393.75 950.94,393.75 950.94,448.31 770.98,448.31 770.98,432.84
		612.08,432.84 612.08,399.45 612.08,390.49 555.08,390.49 555.08,448.31 442.01,452.38 442.01,432.84 271.82,432.84 271.82,446.68
		156.19,446.68 156.19,411.66 140.72,411.66 140.72,316.39 156.19,316.39 156.19,291.96 140.72,291.96 140.72,264.28 156.19,264.28
		156.19,234.15 140.72,234.15 140.72,205.65 156.19,205.65 156.19,182.03 140.72,182.03 140.72,85.95 209.12,85.95 209.12,90.83
		555.08,90.83 	"/>
</g>
</svg>
</template>

<script>
export default {

}
</script>

<style>
  .st2{fill:none;stroke:#1D1D1B;stroke-width:1.5725;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st3{fill:none;stroke:#231F20;stroke-width:6.2079;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}


</style>